module.exports = __webpack_public_path__ + "img/medal5.1b842876.png";